import { Component, Input, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import { AppState } from 'src/app/store/app.states';
import { ComponentBase } from 'src/app/views/component-base';
import { commonState_IsSending, commonState_LatestJourney } from 'src/app/store/common/common.selectors';
import { GoToStepAction } from '../../actions';
import { AppButtonComponent, EntryCheckboxFieldComponent, EntryFieldComponent, Helper } from '@ifaa-components/ui-components';
import { FormGroupState, MarkAsTouchedAction, NgrxFormsModule } from 'ngrx-forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResetDataSavedAction, SaveTfnRequestAction } from './actions';
import { tfn_DataSaved, tfn_Form } from './selectors';
import { AsyncPipe, NgIf, NgTemplateOutlet } from '@angular/common';
import { AppButtonDirective } from 'src/app/directives/appbutton.directive';

@Component({
    selector: 'app-nmj-tfn',
    templateUrl: './nmj-tfn.component.html',
    styleUrls: ['./nmj-tfn.component.scss'],
    imports: [
        ReactiveFormsModule,
        NgrxFormsModule,
        FormsModule,
        AsyncPipe,
        EntryFieldComponent,
        EntryCheckboxFieldComponent,
        AppButtonComponent,
        NgIf,
        NgTemplateOutlet,
        AppButtonDirective
    ],
})
export class NmjTfnComponent extends ComponentBase implements OnInit, OnDestroy {

    @Input() set step(value: number) {
        this.stepIndex = value;
    }

    isLoading$ = this.store.pipe(select(commonState_IsSending));
    journeySteps$ = this.store.pipe(select(commonState_LatestJourney));
    form$ = this.store.pipe(select(tfn_Form));
    dataSaved$ = this.store.pipe(select(tfn_DataSaved));

    helper: Helper = new Helper();
    stepIndex: number = 0;
    nextStep: number = 0;
    previousStep: number = 0;

    constructor(public store: Store<AppState>) {
        super();
    }

    async ngOnInit() {
        super.ngOnInitBase();

        this.sub = this.journeySteps$.subscribe(async x => {
            if (x) {
                this.nextStep = (await this.helper.getValue(this.journeySteps$)).journeySteps.filter(x => x.journeyStep > this.stepIndex)[0]?.journeyStep ?? -1;
                this.previousStep = (await this.helper.getValue(this.journeySteps$)).journeySteps.filter(x => x.journeyStep < this.stepIndex).sort((a, b) => b.journeyStep - a.journeyStep)[0].journeyStep;
            }
        })

        this.sub = this.dataSaved$.subscribe(async x => {
            if (x) {
                // go next step
                this.store.dispatch(GoToStepAction({ index: this.nextStep }));

                // reset data saved prop
                this.store.dispatch(ResetDataSavedAction());
            }
        })
    }

    ngOnDestroy(): void {
        super.ngOnDestroyBase();
    }

    async onMoveBackClick() {
        this.store.dispatch(GoToStepAction({ index: this.previousStep }))
    }

    async onMoveNextClick(
        form: FormGroupState<any>,
    ) {
        if (form.isInvalid) {
            this.store.dispatch(new MarkAsTouchedAction(form.id));
            return;
        }

        var data = (await this.helper.getValue(this.form$)).value;

        this.store.dispatch(
            SaveTfnRequestAction({
                step: this.nextStep,
                field: 'page-change',
                data
            })
        );
    }
}
